import { Sparkles } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./ui/tooltip";
import { VIA_COPILOT_EXPLANATION } from "../lib/activity";

// Next to the person's name wherever the journal shows an action: the action was proposed by the Copilote Jamora and only ran once
// that person approved it — the person stays the author, the badge says how it was done.
export default function ViaCopilotBadge({ className = "" }) {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={`inline-flex shrink-0 items-center gap-1 rounded-full border border-jamora/20 bg-jamora/5 px-1.5 py-0.5 text-2xs font-medium text-jamora ${className}`}
            data-testid="via-copilot"
            aria-label={VIA_COPILOT_EXPLANATION}
            tabIndex={0}
          >
            <Sparkles size={11} aria-hidden="true" />
            Copilote
          </span>
        </TooltipTrigger>
        <TooltipContent>{VIA_COPILOT_EXPLANATION}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
